module.exports = __webpack_public_path__ + "SourceSans3-Regular.ttf.b744e.woff2";